var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.993164 10.8018C1.08647 13.11 2.1605 15.2955 3.98942 16.8985C5.81834 18.5016 8.25965 19.3972 10.7999 19.3972C13.3402 19.3972 15.7814 18.5016 17.6104 16.8985C19.4393 15.2955 20.5133 13.11 20.6067 10.8018",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8066 23.0969V19.713",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9657 15.1972H10.6479C9.36235 15.1972 8.12947 14.7328 7.22046 13.9062C6.31146 13.0797 5.80078 11.9586 5.80078 10.7897V5.3106C5.80078 4.14168 6.31146 3.02063 7.22046 2.19408C8.12947 1.36753 9.36235 0.903137 10.6479 0.903137H10.979C12.2645 0.903137 13.4974 1.36753 14.4064 2.19408C15.3154 3.02063 15.826 4.14168 15.826 5.3106V10.7897C15.826 11.9586 15.3154 13.0797 14.4064 13.9062C13.4974 14.7328 12.2645 15.1972 10.979 15.1972H10.9657Z",
    stroke: "#778797",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMic);
export default __webpack_public_path__ + "static/media/chat_mic.c8392cee81b221ea5a17b37be14dfeff.svg";
export { ForwardRef as ReactComponent };